// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** A frame grows with its chart up to this many widget heights, then scrolls. */
export var CHART_MAX_HEIGHT_FACTOR = 2;
var ROOT_TAG = /^\s*<svg\b([^>]*)>/i;
var VIEW_BOX = /(?:^|\s)viewBox\s*=\s*(["'])(.*?)\1/;
var PIXEL_WIDTH = /(?:^|\s)width\s*=\s*(["'])\s*(\d+(?:\.\d+)?)\s*(?:px)?\s*\1/;
/**
 * The size of a sanitized chart, read from the markup rather than inside the
 * frame, where no script runs. `null` without a usable `viewBox`.
 */
export function chartSize(svg) {
    var _a, _b, _c;
    var attributes = (_a = ROOT_TAG.exec(svg)) === null || _a === void 0 ? void 0 : _a[1];
    if (attributes === undefined)
        return null;
    var viewBox = (_b = VIEW_BOX.exec(attributes)) === null || _b === void 0 ? void 0 : _b[2];
    if (!viewBox)
        return null;
    var parts = viewBox
        .trim()
        .split(/[\s,]+/)
        .map(Number);
    if (parts.length !== 4 || parts.some(function (part) { return !Number.isFinite(part); }))
        return null;
    var boxWidth = parts[2], boxHeight = parts[3];
    if (boxWidth <= 0 || boxHeight <= 0)
        return null;
    var width = Number((_c = PIXEL_WIDTH.exec(attributes)) === null || _c === void 0 ? void 0 : _c[2]);
    return width > 0 ? { aspect: boxHeight / boxWidth, width: width } : { aspect: boxHeight / boxWidth };
}
/**
 * The frame's height: the chart's own at the width it is drawn (its width, at
 * most the frame's), up to {@link CHART_MAX_HEIGHT_FACTOR} widget heights.
 * The widget height when the chart has no shape or the frame is not measured.
 */
export function frameHeight(size, frameWidth, widgetHeight) {
    var _a;
    if (!size || !frameWidth || frameWidth <= 0)
        return widgetHeight;
    var drawn = Math.min(frameWidth, (_a = size.width) !== null && _a !== void 0 ? _a : frameWidth);
    return Math.min(Math.ceil(drawn * size.aspect), CHART_MAX_HEIGHT_FACTOR * widgetHeight);
}
